import { render } from "./Module_Properties.vue?vue&type=template&id=644b1941&scoped=true"
import script from "./Module_Properties.vue?vue&type=script&lang=js"
export * from "./Module_Properties.vue?vue&type=script&lang=js"

import "./Module_Properties.vue?vue&type=style&index=0&id=644b1941&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644b1941"]])

export default __exports__